module.exports = __webpack_public_path__ + "img/warrantySuccess.c8c7be23.png";